import React from 'react';
import { Icon } from '@saviynt/design-system';

import { type Tab, type TabGroupProps } from './type';

import './TabGroup.css';

const TABS: Tab[] = [
  { id: 'overview', label: 'Overview', icon: 'Dashboard' },
  { id: 'fue-inventory', label: 'FUE Inventory', icon: 'Ship' },
  { id: 'role-intelligence', label: 'Role Intelligence', icon: 'Access' },
];

/**
 * TabGroup component for License Details
 * @description Displays a horizontal tab navigation with icons and labels for different license detail views (Overview, FUE Inventory, Role Intelligence).
 * @param {TabGroupProps} props - Component props
 * @param {string} props.activeTab - Currently active tab ID
 * @param {(tabId: string) => void} [props.onTabChange] - Callback fired when a tab is selected
 * @returns {React.ReactElement} Horizontal tab navigation with icon-label buttons
 */
function TabGroup({
  activeTab,
  onTabChange,
}: TabGroupProps): React.ReactElement {
  const handleTabClick = (tabId: string): void => {
    onTabChange?.(tabId);
  };

  return (
    <div className='LicenseManagement-TabGroup'>
      <div className='LicenseManagement-TabGroup-tabs'>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`LicenseManagement-TabGroup-tab ${
              activeTab === tab.id
                ? 'LicenseManagement-TabGroup-tab--active'
                : ''
            }`}
            onClick={() => handleTabClick(tab.id)}
            role='tab'
            aria-selected={activeTab === tab.id}
            type='button'>
            <Icon
              kind={tab.icon}
              size='small'
              className='LicenseManagement-TabGroup-tabIcon'
            />
            <span className='LicenseManagement-TabGroup-tabLabel'>
              {tab.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default TabGroup;
